:host {
  display: inline-flex;
  isolation: isolate;
  position: relative;
  z-index: 100;
}

::slotted(*) {
  display: inline-block;
  position: relative;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Montserrat';
  text-transform: uppercase;
  background: linear-gradient(-45deg, #0ecfad, #0c4f9a);
  background-size: 100%;
  cursor: pointer;
  border: 0px;
  z-index: 100;
  padding: 0 20px;
  line-height: 29px;
  transition: all 0.2s ease-in-out !important;
  text-align: center;
  text-decoration: none;
  border-radius: 50px;
  color: #fff!important;
}

:host([data-size="l"]) ::slotted(*) {
  line-height: 41px;
  padding: 0 30px;
}

::slotted(*:not(:disabled)) {
  cursor: pointer;
}

::slotted(*)::before {
  content: " ";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(-45deg, #0c4f9a, #0ecfad);
  opacity: 0;
  z-index: -100;
  transition: opacity 0.45s;
  border-radius: inherit;
}

::slotted(*:hover) {
  background-color: #25c7cc!important;
  color: #fff!important;
}

::slotted(*:hover)::before {
  opacity: 1;
  background: #24c3c8!important;
}

:host([data-style="secondary"]) ::slotted(*) {
  background: #11142b;
  border: 2px solid #2cd4d9;
  padding: 0 16px;
  line-height: 25px;
  font-weight: normal;
}

:host([data-style="secondary"]) ::slotted(*)::before {
  content: none;
  opacity: 0;
}

:host([data-style="secondary"]) ::slotted(*:hover) {
  background-color: #11142b!important;
  color: #2cd4d9!important;
}
